import { appConfigApi } from "./api.service";

export const STORAGE_KEY = 'LENS_API_API';

export const getLensApi = () => {
    const data = localStorage.getItem(STORAGE_KEY);

    if (!data) {
        return null;
    };

    return JSON.parse(data);
}

export const getVoiceApi = () => getLensApi()?.voice || process.env.REACT_APP_ServerBaseURL;
export const getDigitalApi = () => getLensApi()?.digital || process.env.REACT_APP_Digital_ServerBaseURL;
export const getDashboardUrl = () => getLensApi()?.dashboard

export const baseLensApi = () => new URL(getVoiceApi()).origin;

export const getAppConfig = async () => {
    const { data } = await appConfigApi.get('');
    return data?.data;
}


export const updateAppConfig = async (formData: any) => {
    if (formData.id) {
        await appConfigApi.put('', { ...formData });
    } else {
        await appConfigApi.post('', { ...formData });
    }

    return true;
}



export const deleteAppConfig = async (ids: any[]) => {
    await Promise.all(
        ids.map(async (id:number) => {

            await appConfigApi.delete(`/${id}`);
            return true;
        })
    )
    return true;
}